import SectionFilterButton_vue_vue_type_script_setup_true_lang_default from "./SectionFilterButton.vue_vue_type_script_setup_true_lang.js";
//#region src/components/SectionFilterButton.vue
var SectionFilterButton_default = SectionFilterButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { SectionFilterButton_default as default };

//# sourceMappingURL=SectionFilterButton.vue.js.map